import { useState } from 'react';

import { useSearchParams } from 'next/navigation';

import { Button } from '@/components/ui/button';

import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { APP_ROUTES } from '@/shared/constants/navigation';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';

import { LOGIN_TOKEN_PARAM } from '@/utils/constants';

import { GoogleIcon } from '../icons/svgs';

function GoogleBtn({ insideOnboarding = false }: { insideOnboarding?: boolean }) {
	const searchParams = useSearchParams();
	const searchParamsStr = searchParams.toString();

	const googleAccessToken = decodeURIComponent(searchParams.get(LOGIN_TOKEN_PARAM) ?? '');

	const [disableBtn, setDisableBtn] = useState<boolean>(false);

	const disableGoogleBtn = disableBtn || !!googleAccessToken;

	const handleSubmit = () => {
		setDisableBtn(true);

		if (insideOnboarding)
			emitMixpanelEvent(mixpanelEvents.CLICKED_ONBOARDING_GOOGLE_SIGNIN_BUTTON, {
				feature: MIXPANEL_APP_FEATURES.USER_ONBOARDING_VIA_MODAL,
			});
		else
			emitMixpanelEvent(mixpanelEvents.CLICKED_LOGIN_PAGE_GOOGLE, {
				feature: MIXPANEL_APP_FEATURES.LOGIN_PAGE,
			});

		const url = `${window.location.origin}${APP_ROUTES.GOOGLE_OAUTH}${searchParamsStr ? `?${searchParamsStr}` : ''}`;

		window.open(url, '_self');
	};

	return (
		<Button
			variant="outline"
			className="h-auto w-full rounded-md border border-gray-300 bg-white px-4 py-3 font-semibold text-gray-600 shadow-sm hover:bg-gray-100"
			onClick={handleSubmit}
			disabled={disableGoogleBtn}
		>
			<GoogleIcon className="size-4" />
			Continue with Google
		</Button>
	);
}

export default GoogleBtn;
